// mydatafeed/core/time.js
export const toMs = (s) => s * 1000;
export const toSec = (ms) => Math.floor(ms / 1000);

export const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

// Polyfills y helpers de tiempo (opcional mantenerlos aquí)
if (!Date.prototype.getUnixTime) {
  // eslint-disable-next-line no-extend-native
  Date.prototype.getUnixTime = function () {
    return (this.getTime() / 1000) | 0;
  };
}
if (!Date.now) {
  Date.now = function () { return new Date(); };
}
Date.time = function () { return Date.now().getUnixTime(); };

// Normalización de velas
export const normalizeBars = (minuteCandles = []) =>
  minuteCandles
    .map(c => ({
      time: new Date(c.time).getTime(),   // ms epoch
      open: +c.open,
      high: +c.high,
      low: +c.low,
      close: +c.close,
      volume: c.volume != null ? +c.volume : 0,
    }))
    .sort((a, b) => a.time - b.time);

// Resampling de ticks a OHLC
export const resampleTicks = (ticks = [], intervalMs = 60000) => {
  if (ticks.length === 0) return [];

  const bars = [];
  let currentBar = null;

  ticks.forEach(tick => {
    const tickTime = new Date(tick.timestamp || tick.time || tick.Datetime).getTime();
    const bucketTime = Math.floor(tickTime / intervalMs) * intervalMs;
    const price = +(tick.mid_price || tick.mid || tick.close || tick.price || tick.Precio);

    if (!currentBar || currentBar.time !== bucketTime) {
      if (currentBar) {
        bars.push(currentBar);
      }
      currentBar = {
        time: bucketTime,
        open: price,
        high: price,
        low: price,
        close: price,
        volume: 0
      };
    } else {
      currentBar.high = Math.max(currentBar.high, price);
      currentBar.low = Math.min(currentBar.low, price);
      currentBar.close = price;
    }
  });

  if (currentBar) {
    bars.push(currentBar);
  }

  return bars.sort((a, b) => a.time - b.time);
};
